exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n * Variables\n */\n\n/**\n * Functions\n */\n\n/**\n * Mixins\n */\n", ""]);

// exports
